import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { Link } from "@quintype/components";

import Contributor from "../contributor/index";
import ResponsiveImageWithFallback from "../responsive-image-with-fallback";
import { getStoryData, generateImageSources, checkAppSlug } from "../../utils/utils";
import { isPremium } from "../../../../isomorphic/data/story";

import styles from "./styles.m.css";

const SmallStoryCardCurve = ({
  story,
  className = "",
  cardWithImageZoom = true,
  hasTruncatedHeadline = true,
  setmagazineUTM = null,
  magazineCard = false,
  rasipalapage = false,
  goldpage = false,
  MagazinemainPage = false
}) => {
  const storyData = getStoryData(story);
  const contributor = get(story, ["authors", 0]);
  const contributorRole = get(story, ["authors", 0, "contributor-role", "name"], "");
  const externalLink = get(story, ["metadata", "reference-url"]);
  const checkSlug = checkAppSlug();
  let SourceLink = "";

  const duration = get(story, ["metadata", "story-attributes", "audiolength"], 0);

  const minutes = Math.floor(duration / 60);

  const formatTime = time => {
    if (isNaN(time)) return "";
    const mins = Math.floor(time / 60);
    return `${mins} Min${mins === 1 ? "" : "s"}`;
  };

  const cardurlslug = externalLink || story.url;
  let seturlslug = setmagazineUTM ? `${cardurlslug}?utm_source=${setmagazineUTM}` : cardurlslug;

  if (rasipalapage) {
    seturlslug = `${seturlslug}${seturlslug.includes("?") ? "&" : "?"}pfrom=rasipalan_page`;
  }

  if (checkSlug) {
    SourceLink = externalLink || story.url;
  }

  if (!(storyData.headline && story.url)) {
    return null;
  }

  return (
    <div>
      <div
        className={`${styles["read-more-link"]} ${className} ${cardWithImageZoom ? "card-with-image-zoom" : ""} ${
          magazineCard ? styles["magazinecardtrue"] : styles["magazinecardfalse"]
        } ${rasipalapage ? styles["rasipalapagetrue"] : styles["rasipalapagefalse"]} ${
          goldpage ? styles["goldpagetrue"] : styles["goldpagefalse"]
        } ${MagazinemainPage ? styles["magazinemainpagetrue"] : styles["magazinemainpagefalse"]}`}
      >
        <div className={styles["base"]}>
          <Link
            aria-label={`${"Read full story: "} ${storyData.headline}`}
            href={seturlslug}
            externalLink={SourceLink || externalLink}
          >
            <ResponsiveImageWithFallback
              className={styles["image-wrapper"]}
              slug={storyData.imageS3Key}
              metadata={storyData.imageMetadata}
              isPremium={isPremium(story)}
              alt={storyData.imageCaption}
              imgParams={{ auto: ["format", "compress"] }}
              sources={generateImageSources(
                { aspectRatio: [4, 3], screenWidthCoverage: 0.34 },
                { aspectRatio: [4, 3], screenWidthCoverage: 0.12 }
              )}
              story={story}
            />
          </Link>
          <div className={styles["text-wrapper"]}>
            <Link
              aria-label={`${"Read full story: "} ${storyData.headline}`}
              href={seturlslug}
              externalLink={SourceLink || externalLink}
            >
              <h3 className={`${styles["headline"]} ${hasTruncatedHeadline ? styles["truncated"] : ""} `}>
                {storyData.headline}
              </h3>
            </Link>
            <div className={styles["contributor-listen-wrapper"]}>
              {contributor &&
                !goldpage &&
                !rasipalapage && (
                  <Contributor
                    name={contributor["name"]}
                    type={contributorRole}
                    iconColor="#4a4a4a"
                    className={styles["contributor"]}
                  />
                )}
              {MagazinemainPage &&
                minutes > 0 && (
                  <Link
                    href={`${seturlslug}${seturlslug.includes("?") ? "&" : "?"}play=true`}
                    externalLink={!!externalLink}
                  >
                    <div className={styles["listen-now"]}>
                      <img
                        src="https://images.assettype.com/vikatan/2025-09-08/gf551pnp/icon-headset.png"
                        alt="Listen"
                      />
                      <span className={styles["listen-now-text"]}>
                        Listen <i className={styles["readtime"]}>{formatTime(duration)}</i>
                      </span>
                    </div>
                  </Link>
                )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SmallStoryCardCurve.propTypes = {
  magazineCard: PropTypes.bool,
  hasTruncatedHeadline: PropTypes.bool,
  className: PropTypes.string,
  setmagazineUTM: PropTypes.string,
  cardWithImageZoom: PropTypes.bool,
  rasipalapage: PropTypes.bool,
  goldpage: PropTypes.bool,
  MagazinemainPage: PropTypes.bool,
  story: PropTypes.shape({
    id: PropTypes.string,
    authors: PropTypes.arrayOf(
      PropTypes.shape({
        "contributor-role": PropTypes.shape({
          name: PropTypes.string
        }),
        name: PropTypes.string
      })
    ),
    headline: PropTypes.string.isRequired,
    metadata: PropTypes.shape({
      "reference-url": PropTypes.string
    }),
    alternative: PropTypes.shape({
      home: PropTypes.shape({
        default: PropTypes.shape({
          headline: PropTypes.string
        })
      })
    }),
    slug: PropTypes.string.isRequired,
    "hero-image-metadata": PropTypes.shape({
      height: PropTypes.number,
      width: PropTypes.number,
      "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
    }),
    "hero-image-s3-key": PropTypes.string,
    "hero-image-caption": PropTypes.string
  })
};

export default SmallStoryCardCurve;
